import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

const COOKIE_CONSENT_KEY = 'almaley_cookie_consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!stored) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({ necessary: true, analytics: true }));
    setVisible(false);
  };

  const rejectOptional = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({ necessary: true, analytics: false }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <p>
          Usamos cookies necesarias para el funcionamiento de la plataforma.
          Consulta nuestra <Link to="/legal/cookies">Política de cookies</Link> para más información.
        </p>
        <div className="cookie-banner-actions">
          <button className="cookie-btn cookie-btn-secondary" onClick={rejectOptional}>
            Solo necesarias
          </button>
          <button className="cookie-btn cookie-btn-primary" onClick={accept}>
            Aceptar todas
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
